<template lang="pug">
.room-details-wrapper
  .d-flex.justify-content-around.room-details-info
    .room-details-group
      img.details-icon(src='/images/tournament/poolsize-icon.svg')
      .title {{ $t("ui.total_winning") }}
      .text {{ roomData.pool }}
    .room-details-group
      img.details-icon(src='/images/tournament/players-icon.svg')
      .title {{ $t("ui.players") }}
      .text {{ roomData.room_count }} / {{ roomData.room_limit }}
    .room-details-group
      img.details-icon(src='/images/tournament/match-icon.svg')
      .title {{ $t("ui.matches") }}
      .text {{ roomData.total_match }}
    .room-details-group
      img.details-icon(src='/images/tournament/entryfee-icon.svg')
      .title {{ $t("ui.entry_fee") }}
      .text(v-if="roomData.room_rate > 0") {{ roomData.room_rate }}
      .text(v-else) {{ $t("ui.free_room") }}
  .d-flex.justify-content-between.room-details-row
    div
      img.trophy-icon(src='/images/tournament/trophy1.svg')
      | {{ $t("ui.first_prize") }}
    div {{ roomData.prize1 }}
  template(v-if="roomData.formula == 1")
    .d-flex.justify-content-between.room-details-row
      div
        img.trophy-icon(src='/images/tournament/trophy2.svg')
        | {{ $t("ui.second_prize") }}
      div {{ roomData.prize2 }}
    .d-flex.justify-content-between.room-details-row
      div
        img.trophy-icon(src='/images/tournament/trophy3.svg')
        | {{ $t("ui.third_prize") }}
      div {{ roomData.prize3 }}
</template>

<script>
export default {
  props: {
    roomData: {
      type: Object,
    },
  },
};
</script>